import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCheckbox,_vm._b({attrs:{"false-value":false,"true-value":true,"input-value":_vm.input,"hide-details":""},on:{"change":_vm.changeState}},'v-checkbox',_vm.commonProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }